export const Routes = {
  authentication: '/authentication',
  closingTime: '/closingTime/',
  contact: '/contact',
  createBook: '/create-book/',
  createEvent: '/create-event',
  dashboard: '/dashboard',
  editBasic: '/edit-basic/',
  editClosing: '/edit-closing/',
  editWelcome: '/edit-welcome/',
  entryFeed: '/feed/',
  entryForm: '/entry/',
  eventDetail: '/event-detail/',
  invitationEditor: '/invitation-editor/',
  landing: '/',
  ownerFeed: '/host-feed/',
  pricing: '/pricing',
  privacy: '/privacy',
  redirectPage: '/successful-login',
  settings: '/settings',
  shareEvent: '/share-event',
  terms: '/terms-of-use',
  welcomeEvent: '/welcome/',
}
